<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "contentAwait",
  components: {
    ContentLoader
  }
};
</script>

<template>
  <div id="content">
    <content-loader
      :height="90"
      :width="830"
      :speed="3"
      primaryColor="#D7D9DB"
      secondaryColor="#868E92"
    >
      <rect x="86.74" y="23.27" rx="3" ry="3" width="574" height="10.496" />
      <rect x="191" y="109" rx="3" ry="3" width="380" height="6.4" />
      <rect x="0" y="120" rx="3" ry="3" width="201" height="6.4" />
      <circle cx="44" cy="48" r="30" />
      <rect x="87.75" y="42.27" rx="3" ry="3" width="574" height="10.496" />
      <rect
        x="87.75"
        y="61.41"
        rx="3"
        ry="3"
        width="308"
        height="11.072000000000001"
      />
      <rect x="718.4" y="16.24" rx="0" ry="0" width="90" height="54" />
      <rect x="35.4" y="47.24" rx="0" ry="0" width="1" height="16" />
      <rect x="42.4" y="41.24" rx="0" ry="0" width="0" height="0" />
    </content-loader>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#content {
  background: $light;
  cursor: pointer;
  padding: 1em 1.5em;
  box-shadow: 0 1px 3px 0 rgba(32, 33, 36, 0.28);
  border-radius: 0.375rem;
  border-color: $primary-dark;
  border-width: 0.2px;
  min-height: 80px;
}
</style>
